import { isArray, isNumber, isObject, isString } from '../../utils/baseAssert';
const AGS_GEOMETRY_TYPE = ['esriGeometryPoint', 'esriGeometryPolyline', 'esriGeometryPolygon'];
const AGS_FIELD_TYPE = [
    'esriFieldTypeOID',
    'esriFieldTypeInteger',
    'esriFieldTypeSmallInteger',
    'esriFieldTypeSingle',
    'esriFieldTypeString',
    'esriFieldTypeDouble',
    'esriFieldTypeDate',
];
const isAGSResponseField = (field) => {
    if (!isObject(field)) {
        return false;
    }
    if (!Object.hasOwn(field, 'name') || !isString(field.name)) {
        return false;
    }
    if (!Object.hasOwn(field, 'alias') || !isString(field.alias)) {
        return false;
    }
    if (Object.hasOwn(field, 'length') && !isNumber(field.length)) {
        return false;
    }
    if (!Object.hasOwn(field, 'type')) {
        return false;
    }
    const type = field.type;
    if (!isString(type) || !AGS_FIELD_TYPE.includes(type)) {
        return false;
    }
    return true;
};
const isPath = (path) => {
    if (!isArray(path) ||
        !path.every((coordinate) => {
            return isArray(coordinate) && coordinate.every(isNumber);
        })) {
        return false;
    }
    return true;
};
const isPaths = (paths) => {
    if (!isArray(paths) || !paths.every(isPath)) {
        return false;
    }
    return true;
};
const isAGSResponseFeature = (feature) => {
    if (!isObject(feature)) {
        return false;
    }
    if (!Object.hasOwn(feature, 'attributes')) {
        return false;
    }
    const attributes = feature.attributes;
    if (!isObject(attributes)) {
        return false;
    }
    // TODO ma attributes dle fields
    if (!Object.hasOwn(feature, 'geometry')) {
        return false;
    }
    const geometry = feature.geometry;
    if (!isObject(geometry)) {
        return false;
    }
    if (Object.hasOwn(geometry, 'x') && !isNumber(geometry.x)) {
        return false;
    }
    if (Object.hasOwn(geometry, 'y') && !isNumber(geometry.y)) {
        return false;
    }
    if (Object.hasOwn(geometry, 'paths') &&
        !isPaths(geometry.paths) &&
        !isPath(geometry.paths)) {
        return false;
    }
    if (Object.hasOwn(geometry, 'rings')) {
        const rings = geometry.rings;
        if (!isArray(rings) || (!rings.every(isPaths) && !rings.every(isPath))) {
            return false;
        }
    }
    return true;
};
const isAGSResponse = (data) => {
    if (!isObject(data)) {
        return false;
    }
    if (!Object.hasOwn(data, 'geometryType')) {
        return false;
    }
    const geometryType = data.geometryType;
    if (!isString(geometryType) || !AGS_GEOMETRY_TYPE.includes(geometryType)) {
        return false;
    }
    if (!Object.hasOwn(data, 'fields')) {
        return false;
    }
    const fields = data.fields;
    if (!isArray(fields) || !fields.every(isAGSResponseField)) {
        return false;
    }
    if (!Object.hasOwn(data, 'features')) {
        return false;
    }
    const features = data.features;
    if (!isArray(features) || !features.every(isAGSResponseFeature)) {
        return false;
    }
    return true;
};
export const assertAGSResponse = (data) => {
    if (!isAGSResponse(data)) {
        throw new Error('Unsupported response from ArcGIS service.');
    }
    return data;
};
//# sourceMappingURL=AGSFeature.js.map